module.exports = "https://web-assets.ifttt.com/packs/media/icons-v2/error-23dd88db.svg";